import React, { useState } from 'react';
import {
  Button, ButtonGroup, makeStyles, Box, Dialog, Slide, Typography,
} from '@material-ui/core';
import MapIcon from '@material-ui/icons/Map';
import FilterListIcon from '@material-ui/icons/FilterList';
import { MapSection } from 'views/motorcycle_rental/components/MapSection/MapSection';

import OverlayStyle from 'views/motorcycle_rental/components/widget/OverlayStyle';
import { withTranslation } from 'config/i18n';
import CloseIcon from '@material-ui/icons/Close';
import Filters from 'views/motorcycle_rental/components/filters/Filters';
import { getFiltersProps } from 'views/motorcycle_rental/utils/helpers';

const useStyles = makeStyles((theme) => ({
  btnBox: {
    position: 'fixed',
    bottom: theme.spacing(2),
    left: '50%',
    marginLeft: theme.spacing(-18.75),
    width: theme.spacing(37.5),
    zIndex: 2,
    '& button': {
      width: '50%',
      borderRadius: theme.spacing(3),
      padding: theme.spacing(1.5, 2),
      '& svg': {
        marginRight: theme.spacing(1),
        width: theme.spacing(2.25),
      },
    },
  },
  btnGp: {
    width: '100%',
    boxShadow: 'none',
  },
  ...OverlayStyle(theme),
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const MapFiltersBtns = (props) => {
  const {
    t,
    rentalData,
    handleFieldChange,
    handleClearAllFilters,
    selectedPlace,
    handleBikeCardClick,
    isWidgetOpen,
    filtersModalOpen,
    handleFilterDialogOpen,
    handleFilterDialogClose,
  } = props;
  const classes = useStyles();

  const [mapModalOpen, setMapModalOpen] = useState(false);

  const filtersProps = getFiltersProps(rentalData, handleFieldChange);

  return (
    <Box className={classes.btnBox}>
      <ButtonGroup
        variant="contained"
        color="primary"
        aria-label="contained primary button group"
        className={classes.btnGp}
      >
        <Button onClick={() => setMapModalOpen(true)}>
          <MapIcon />
          {t('fe_geo_filters:show_map')}
        </Button>
        <Button onClick={handleFilterDialogOpen}>
          <FilterListIcon />
          {t('fe_geo_filters:filters')}
        </Button>
      </ButtonGroup>
      {/* filters Dialog */}
      <Dialog
        fullScreen
        open={filtersModalOpen}
        onClose={handleFilterDialogClose}
        TransitionComponent={Transition}
        className={classes.placeModalRoot}
      >
        <Box p={2} pt={5}>
          <Box className={classes.overlayHeader}>
            <Typography className={classes.overlayTitle}>
              {t('fe_geo_filters:filters')}
            </Typography>
            <CloseIcon onClick={handleFilterDialogClose} className={classes.closeIcon} />
          </Box>
          <Box>
            <Filters data={{ ...filtersProps, variant: 'outlined' }} />
          </Box>
        </Box>
        <Box display="flex" p={2} justifyContent="stretch">
          <Box mr={1} width="50%">
            <Button onClick={handleClearAllFilters} variant="outlined" color="secondary" fullWidth>
              {t('fe_geo_filters:clear_all')}
            </Button>
          </Box>
          <Box ml={1} width="50%">
            <Button onClick={handleFilterDialogClose} variant="contained" color="primary" fullWidth>
              {t('fe_geo_filters:search')}
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* Map Dialog */}
      <Dialog
        fullScreen
        open={mapModalOpen}
        onClose={() => setMapModalOpen(false)}
        TransitionComponent={Transition}
        className={classes.placeModalRoot}
      >
        <MapSection
          rentals={rentalData?.rentals}
          selectedPlace={selectedPlace}
          handleBikeCardClick={handleBikeCardClick}
          isWidgetOpen={isWidgetOpen}
          handleClose={() => {
            setMapModalOpen(false);
          }}
        />
      </Dialog>
    </Box>
  );
};
export default withTranslation(['fe_geo_filters'])(MapFiltersBtns);
